import { render, staticRenderFns } from "./ModalConfirmMessages.vue?vue&type=template&id=c8650802"
import script from "./ModalConfirmMessages.vue?vue&type=script&lang=js"
export * from "./ModalConfirmMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports